import { CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router';

export default function HeroSection({
  title,
  description,
  subDescription,
  image,
  buttons,
  blueTitle,
  imageClassName,
  imageContainerClassName,
}: {
  title: string;
  description?: string;
  subDescription?: string;
  image: string;
  buttons: {
    text: string;
    link: string;
    variant: 'default' | 'outline' | 'link';
  }[];
  blueTitle?: string;
  imageClassName?: string;
  imageContainerClassName?: string;
}) {
  return (
    <div className="flex flex-col items-center justify-between gap-20 md:flex-row">
      <div className="flex w-full flex-col gap-4 md:w-1/2">
        {blueTitle && (
          <span className="text-lightBlue text-[15px] font-bold uppercase">{blueTitle}</span>
        )}
        <h1 className="mb-5 text-4xl font-bold">{title}</h1>
        {description && <p className="text-lighterBlack py-7 text-lg">{description}</p>}
        <div className="flex gap-4">
          {buttons.map((button) => {
            const isExternal = /^https?:\/\//.test(button.link);
            return (
              <Button key={button.text} variant={button.variant} asChild>
                {isExternal ? (
                  <a href={button.link} target="_blank" rel="noopener noreferrer">
                    {button.text}
                  </a>
                ) : (
                  <Link to={button.link}>{button.text}</Link>
                )}
              </Button>
            );
          })}
        </div>
        {subDescription && (
          <div className="flex items-center gap-2">
            <CheckCircle className="text-lightBlue h-4 w-4" />
            <span className="text-lightBlack text-sm font-light">{subDescription}</span>
          </div>
        )}
      </div>
      <div
        className={`flex items-center justify-center ${imageContainerClassName ?? ''}`.trim()}
      >
        <img
          src={image}
          alt={title}
          className={imageClassName ?? 'h-full w-full object-cover'}
        />
      </div>
    </div>
  );
}
